// Response shapes de los endpoints del pilot. Fuente de verdad única —
// web y api importan de acá para eliminar drift (audit encontró 4 tipos
// duplicados y 3 bugs históricos por desalineación App.tsx ↔ LearnerEntry).
//
// Zod para runtime validation opcional (no activo en response: {} del route
// por riesgo de ResponseSerializationError con .optional; usable en parseo
// defensivo del SPA si algún día lo queremos).
import { z } from 'zod';
import { Dim, DictamenState, Modality } from '../primitives.js';
// Reflejo del shape que devuelve computeDictamen + insertDictamen (spec §22).
export const DictamenSchema = z.object({
    id: z.string(),
    session_id: z.string(),
    global_score: z.number(),
    state: DictamenState,
    confidence: z.number(),
    dim_recuperacion: z.number(),
    dim_comprension: z.number(),
    dim_analisis: z.number(),
    dim_transferencia: z.number(),
    weights_marzano: z.record(Dim, z.number()),
    weights_internal: z.record(Dim, z.record(z.string(), z.number())),
    weights_justification: z.string().nullable(),
    total_penalty_pct: z.number(),
    evidence_count_by_dim: z.record(Dim, z.number()),
    gaps_detected: z
        .object({ gaps: z.array(z.string()), common_errors_observed: z.array(z.string()) })
        .nullable(),
    recommendations: z
        .object({ student: z.array(z.string()), teacher: z.array(z.string()) })
        .nullable(),
    ai_emitted_at: z.string(),
});
export const AiSuspicionSignalSchema = z.object({
    level: z.enum(['low', 'medium', 'high']),
    confidence: z.number(),
    reasons: z.array(z.string()),
});
// POST /v1/pilots/:id/turn (text) y /turn-audio comparten shape base.
// El audio agrega `transcript` + `whisper_latency_ms`.
export const TurnResponseSchema = z.object({
    closed: z.boolean(),
    next_question: z.string().nullable(),
    current_dim: Dim.nullable(),
    block_signal: z.boolean(),
    evidence_counts: z.record(z.number()),
    dictamen: DictamenSchema.nullable().optional(),
    transcript: z.string().optional(),
    whisper_latency_ms: z.number().optional(),
    ai_suspicion: AiSuspicionSignalSchema.optional(),
});
export const RegisterHelpResponseSchema = z.object({
    ok: z.literal(true),
    penalty_pct: z.number(),
    help_text: z.string(),
    replacement_question: z.string().nullable(),
    occurred_at: z.string(),
});
export const ClosePilotResponseSchema = z.object({
    dictamen: DictamenSchema,
});
// GrantedHelpItem viajaba entre 2 componentes React locales. Lo movemos
// acá para que compartan schema con lo que persiste evaluation_event
// HELP_GRANTED (aunque acá es solo el shape UI).
export const GrantedHelpItemSchema = z.object({
    help_type: z.enum(['aclaracion', 'reformulacion', 'pista_parcial', 'pista_significativa']),
    penalty_pct: z.number(),
    at: z.string(),
    dim: Dim.nullable(),
});
//# sourceMappingURL=pilot-responses.js.map